import { useContext } from 'react';
import { makeStyles } from '@mui/styles';
import { getCurrentChapter } from '@openclassrooms/ui-web/table-of-content';
import Typography from '@classify/react-core-components/Typography';
import { translate } from '@openclassrooms/translations';

import AnonymousLoginBanner from '../AnonymousLoginBanner';
import QuizSkeleton from './QuizSkeleton';
import CourseContext from '../../contexts/courseContext';
import learningAtOC from './images/learning_at_OC.svg';

interface Props {
  exerciseId: number;
}

const useStyles = makeStyles(({ spacing }) => ({
  title: {
    margin: spacing(4, 0, 5, 0),
  },
}));

const QuizAnonymous = ({ exerciseId }: Props) => {
  const classes = useStyles();
  const { flatToc } = useContext(CourseContext);

  const currentChapter = getCurrentChapter(flatToc, exerciseId);

  return (
    <>
      <Typography variant="h2" className={classes.title}>
        {currentChapter.title}
      </Typography>
      <AnonymousLoginBanner
        title={translate('quizpage.not_logged.login_banner.title')}
        description={translate('quizpage.not_logged.login_banner.desc')}
        image={learningAtOC}
      />
      <QuizSkeleton />
    </>
  );
};

export default QuizAnonymous;
